import moment from 'moment';
import EditIcon from '../../assets/icons/EditIcon';

import './leads.scss';

const LeadNotes = (props) => {
  const { notes = [], currentUserId, onEditClick } = props;

  return (
    <div className="lead-activity__container">
      <div className='lead-activity__activity-items-list'>
        {notes?.length ? (
          notes?.map((item) => (
            <div key={item.id} className='lead-activity__activity-item'>
              <div className='d-flex space-between'>
                <div className='font-bold'>
                  {item.authorFullName}
                </div>
                <div className='d-flex' style={{ alignItems: 'center' }}>
                  <div className='font-size-sm secondary'>
                    {moment(item.createdAt).local().fromNow()}
                  </div>
                  {currentUserId === item.authorId && (
                    <div className='pointer m-l-md' onClick={() => onEditClick(item)}>
                      <EditIcon fontSize='small' color="var(--app-text)" />
                    </div>
                  )}
                </div>
              </div>
              <div className='m-t-md'>
                {item.note}
              </div>
            </div>
          ))
        ) : (
          <div className='p-lg font-size-bg font-bold secondary d-flex flex-center'>
            No Notes
          </div>
        )}
      </div>
    </div>
  );
};

export default LeadNotes;
